module.exports = __webpack_public_path__ + "static/media/todo-home.b7ed0eaf.png";